import { render, staticRenderFns } from "./Labeller.vue?vue&type=template&id=71e93024&"
import script from "./Labeller.vue?vue&type=script&lang=js&"
export * from "./Labeller.vue?vue&type=script&lang=js&"
import style0 from "./Labeller.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports